import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    totalesGenerales: []
}

export const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        setTotalesGenerales: (state, action) => {
            state.totalesGenerales = action.payload
        }
    }
})

export const { setTotalesGenerales } = reportsSlice.actions

export default reportsSlice.reducer
